{
  "tags": {
    "new": "New",
    "guaranteed": "Guaranteed"
  },
  "claim": "Claim",
  "claimed": "Claimed",
  "progress": "Progress: {{title}}",
  "rewardUnavailable": "Reward unavailable",
  "rewardFor": "{{parts}} for {{name}}",
  "rewardNamed": "{{parts}}: {{name}}",
  "forName": "for {{name}}",
  "choiceCard": "on a card you choose",
  "xp": "+{{xp}} EXP",
  "cards": {
    "which": "Which card?",
    "place_one": "{{count}} fragment to place on a card you own.",
    "place_other": "{{count}} fragments to place on a card you own.",
    "search": "Search for a card…",
    "emptyTitle": "No cards",
    "emptyBody": "Get a character first, then come back to place these fragments."
  },
  "boosters": {
    "title": "The booster counter",
    "intro": "Choose a pack, check its guarantees and discover your next cards.",
    "openFailed": "Couldn’t open",
    "type": "Booster type",
    "unavailable": "Unavailable",
    "giftedBadge_one": "{{count}} gifted",
    "giftedBadge_other": "{{count}} gifted",
    "preview": "Preview of {{name}}",
    "quantity": "Number of boosters",
    "openOne": "Open 1 booster",
    "openTen": "Open 10 boosters",
    "openMax_one": "Open the maximum ({{count}} booster)",
    "openMax_other": "Open the maximum ({{count}} boosters)",
    "openMaxUnavailable": "Open the maximum (unavailable)",
    "max": "Max",
    "maxCount": "Max ×{{count}}",
    "opening": "Opening…",
    "openFree": "Open for free",
    "open": "Open",
    "openCount": "Open ×{{count}}",
    "reserveEmptyIn": "The reserve is empty. The next booster arrives in {{time}}.",
    "reserveEmptySoon": "The reserve is empty. The next booster arrives soon.",
    "giftedHint_one": "{{formatted}} gifted booster, without spending Anima",
    "giftedHint_other": "{{formatted}} gifted boosters, without spending Anima",
    "unavailableNow": "Unavailable for now.",
    "shortfall": "You’re short {{amount}} Anima. <link>Quests</link> can award boosters.",
    "xp_one": "+{{xp}} EXP for this opening.",
    "xp_other": "+{{xp}} EXP for these {{count}} openings.",
    "odds": "Odds",
    "reserve": "Reserve {{charges}}/{{max}}",
    "reserveFull": "Reserve full",
    "nextCharge": "+1 in {{time}}",
    "recharging": "Recharging",
    "reserveCap": "Max {{max}} (10 + level). A full recharge takes 1 hour.",
    "history": "Recent openings",
    "free": "Free",
    "duplicateDisplay": "Duplicates when opening",
    "duplicateAsCard": "Card",
    "duplicateAsFragment": "Fragments"
  },
  "reveal": {
    "noNew": "No new characters",
    "newCharacters_one": "{{count}} new character",
    "newCharacters_other": "{{count}} new characters",
    "noDuplicates": "no duplicates",
    "duplicates_one": "{{count}} duplicate converted into {{fragments}} fragments",
    "duplicates_other": "{{count}} duplicates converted into {{fragments}} fragments",
    "summary": "{{fresh}}, {{converted}}.",
    "added": "New character added to your collection",
    "converted": "Duplicate converted into {{gained}} fragments ({{total}} total)",
    "pity": "Pity guarantee: {{rarity}} or better",
    "opening": "Opening: {{name}}",
    "cardOf": "Card {{current}} of {{total}}",
    "cardContinue": "{{name}}, {{rarity}}. {{action}}",
    "flipCard": "Flip the card",
    "flipHint": "Tap the card to flip it",
    "nextCard": "Next card",
    "seeResult": "See the result",
    "flip": "Flip",
    "revealAll": "Reveal all",
    "animeCompleted": "Work completed",
    "balance": "Balance",
    "finish": "Done",
    "openAgain": "Open again",
    "achievementsReached_one": "Achievement unlocked!",
    "achievementsReached_other": "{{count}} achievements unlocked!",
    "tierReady": "Tier {{tier}} reached",
    "tiersReady": "Tiers {{from}} to {{to}} reached",
    "claimAchievements": "Claim my achievements",
    "skip": "Skip",
    "fragmentsLabel": "fragments",
    "duplicateTile": "{{name}}, {{rarity}}, duplicate: +{{gained}} fragments ({{total}} total)"
  },
  "rates": {
    "rarity": "Rarity",
    "probability": "Probability",
    "fragments": "Fragments",
    "guarantees": "Guarantees",
    "orBetter": "{{rarity}} or better",
    "counter": "{{rarity}} guarantee counter",
    "next": "Guaranteed on the next opening",
    "within_one": "Guaranteed within {{count}} opening",
    "within_other": "Guaranteed within {{count}} openings",
    "live": "These rates are set in the game configuration: they do not depend on the catalogue size."
  },
  "harvest": {
    "howTitle": "How is the reward pool shared?",
    "pageTitle": "Anima harvest",
    "intro": "Open boosters to take part in this month’s reward pool.",
    "bannerAlt": "Anima Harvest: opening boosters and a shared jackpot",
    "ends": "Sharing in {{time}}",
    "ruleBefore": "Fees of {{saleFee}}% on sales, auctions, and trades fill this jackpot. A system buyback pays {{buybackPot}}% of its price into it ({{buyback}}% of the card’s value). A free booster adds",
    "ruleAfter": ", and a paid booster adds {{saleFee}}% of its price (rounded up). At the end of the month, the jackpot is shared in full among players who opened boosters, according to their share of openings.",
    "yours": "Your participation",
    "opened": "Opened",
    "share": "Share",
    "place": "Rank",
    "estimated": "Estimated",
    "none": "You haven’t opened a booster this month. <link>Open one</link> to join the share.",
    "ranking": "Leaderboard",
    "boosterCount_one": "{{formatted}} booster",
    "boosterCount_other": "{{formatted}} boosters",
    "waiting": "Nobody has opened a booster yet. The jackpot is waiting.",
    "outside_one": "You’re {{place}} with {{openings}} booster, {{share}} of the total.",
    "outside_other": "You’re {{place}} with {{openings}} boosters, {{share}} of the total.",
    "last": "Last harvest",
    "previousMonth": "{{month}}:",
    "previousShared_one": "shared across {{openings}} booster.",
    "previousShared_other": "shared across {{openings}} boosters.",
    "yourCut": "Your share:"
  },
  "quests": {
    "title": "Quests and achievements",
    "claimable_one": "{{count}} to claim",
    "claimable_other": "{{count}} to claim",
    "endsIn": "Ends in {{time}}",
    "newIn": "New quests in {{time}}",
    "achievementsIntro": "Every achievement climbs in endless tiers: the goal and the reward grow with each one. Nothing is paid out on its own, come and claim your tiers. Every 5 tiers grants a unique cosmetic to equip.",
    "intro": "Four quests a day, four bigger ones over 7 days, and three big ones over the month. The reward is drawn at random, and the goal matches what it’s worth. Don’t like one? You can swap one quest per period.",
    "category": "Category",
    "day": "Day",
    "week": "Week",
    "achievements": "Achievements",
    "endsHint": "These quests end in {{time}}.",
    "renewHint": "These quests refresh in {{time}}.",
    "done": "Quest complete: {{title}}",
    "reroll": "Swap",
    "rerollFailed": "Couldn’t swap this quest",
    "filterAll": "All",
    "filterReady": "Ready to claim",
    "noneReady": "No tier to claim right now."
  },
  "achievements": {
    "xp": "experience points",
    "tier": "Tier {{tier}}",
    "tierTitle": "{{title}} — tier {{tier}}",
    "claimedTiers_one": "{{count}} tier claimed",
    "claimedTiers_other": "{{count}} tiers claimed",
    "claim": "Claim",
    "claimMany": "Claim (×{{count}})"
  },
  "calendar": {
    "todayTitle": "Your reward today",
    "legend": { "anima": "Anima", "fragments": "Fragments", "boosters": "Boosters", "cards": "Characters" },
    "title": "Calendar",
    "combo": "Combo {{count}}",
    "monthBonus": " · +{{percent}}% this month",
    "nextBonus": " · next month +{{percent}}%",
    "ready": "Reward ready",
    "newDay": "New day in {{time}}",
    "month": "Month {{month}}",
    "grid": "This month’s calendar",
    "day": "Day {{day}}, {{kind}}{{amount}}, {{status}}",
    "amount": ", {{amount}}",
    "today": "Today’s login",
    "weekdays": {
      "mon": "M",
      "tue": "T",
      "wed": "W",
      "thu": "T",
      "fri": "F",
      "sat": "S",
      "sun": "S"
    },
    "kinds": {
      "fragments": "Fragments",
      "anima": "Anima",
      "booster_standard": "Standard Booster",
      "booster_premium": "Premium Booster",
      "booster_legendary": "Lucky Booster",
      "character_legendary": "Legendary character",
      "character_mythic": "Mythic character",
      "character_divine": "Divine character"
    },
    "status": {
      "claimed": "claimed",
      "missed": "missed",
      "claimable": "to claim",
      "locked": "locked"
    }
  }
}
